import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Cadastro from '@/components/Cadastro'
import Dashboard from '@/components/Dashboard'
import Agendamentos from '@/components/Agendamentos'
import Pedidos from '@/components/Pedidos'
import Metas from '@/components/Metas'
import Premios from '@/components/Premios'
import Catalogo from '@/components/Catalogo'
import Conta from '@/components/Conta'
import Contato from '@/components/Contato'
import Chat from '@/components/Chat'
import Logs from '@/components/Logs'
import AlterarSenha from '@/components/AlterarSenha'
import RecuperarSenha from '@/components/RecuperarSenha'
import Usuarios from '@/components/Usuarios'
import Clientes from '@/components/Clientes'
import Empresas from '@/components/Empresas'
import PrecosEspeciais from '@/components/PrecosEspeciais'
import Estoque from '@/components/Estoque'
import Notificacoes from '@/components/Notificacoes'
import GerenciarNotificacoes from '@/components/GerenciarNotificacoes'
import Alertas from '@/components/Alertas'
import GerenciarAlertas from '@/components/GerenciarAlertas'
import Relatorios from '@/components/Relatorios'
import GerenciarEmpresas from '@/components/GerenciarEmpresas'
import GerenciarCatalogo from '@/components/GerenciarCatalogo'
import GerenciarMetas from '@/components/GerenciarMetas'
import GerenciarEstoque from '@/components/GerenciarEstoque'
import GerenciarEstoqueArmazenamento from '@/components/GerenciarEstoqueArmazenamento'
import MovimentarEstoque from '@/components/MovimentarEstoque'
import ResgatarPremios from '@/components/ResgatarPremios'
import GerenciarPremios from '@/components/GerenciarPremios'
import ResgatePremios from '@/components/ResgatePremios'
import GerenciarClientes from '@/components/GerenciarClientes'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import GerenciarPedidos from '@/components/GerenciarPedidos'
import PreAgendar from '@/components/PreAgendar'
import PrecosEspeciaisGranel from '@/components/PrecosEspeciaisGranel'
import Arquivos from '@/components/Arquivos'
import Pagamentos from '@/components/Pagamentos'
import Avaliacao from '@/components/Avaliacao'
import Avaliacoes from '@/components/Avaliacoes'
import { isMobile } from 'mobile-device-detect';
const loggedRoute 		= "Dashboard";
const notLoggedRoute 	= "Login";

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    if (typeof to.meta.auth == "undefined") {
    	next();
    	return;
    }
    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false) {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	console.log("Esta logado e a pagina nao permite", _this);
				 	if (_this.currentRoute.params.reload == 1) {
				 		console.log("Faz reload")
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            }

        } catch(err) {
            // return false;
        }
    }

 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
	// mode: 'history',
  	routes: [
	    {
	      	path: '/',
	      	name: 'Dashboard',
	      	meta: {
	      		title: 		"Visão geral",
	      		auth: 		true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Dashboard,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    },  
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },	      
	    {
	      	path: '/contato/',
	      	name: 'Contato',
	      	meta: {
	      		title: 		"Contato",
		      	level: 		["contratante"],
		      	backButton: true,
	      		auth: 		true
	      	},
	      	component: Contato,
	      	beforeEnter: checkLogin,
	    },  	      
	    // {
	    //   	path: '/dashboard/',
	    //   	name: 'Dashboard',
	    //   	meta: {
	    //   		title: 		"Visão geral",
		   //    	auth: 		true,
		   //    	level: 		["contratante", "admin", "prestador"],
	    //   	},
	    //   	component: Dashboard,
	    //   	beforeEnter: checkLogin,
	    // },
	    {
	      	path: '/agendamentos/',
	      	name: 'Agendamentos',
	      	meta: {
	      		title: 		"Agendamentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Agendamentos,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/metas/',
	      	name: 'Metas',
	      	meta: {
	      		title: 		"Metas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: Metas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/abastecimentos/',
	      	name: 'Pedidos',
	      	meta: {
	      		title: 		"Abastecimentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Pedidos,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/avaliacoes/',
	      	name: 'Avaliacoes',
	      	meta: {
	      		title: 		"Avaliações recebidas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Avaliacoes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/avaliacao/',
	      	name: 'Avaliacao',
	      	meta: {
	      		title: 		"Avaliação",
		      	// auth: 		true,
		      	backButton: true,
		      	// level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Avaliacao,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/alertas/',
	      	name: 'Alertas',
	      	meta: {
	      		title: 		"Alertas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Alertas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/alertas/cadastro/',
	      	name: 'CadastrarAlertas',
	      	meta: {
	      		title: 		"Cadastrar alerta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarAlertas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/alertas/editar/',
	      	name: 'EditarAlertas',
	      	meta: {
	      		title: 		"Editar alerta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarAlertas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/lembretes/',
	      	name: 'Notificacoes',
	      	meta: {
	      		title: 		"Lembretes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Notificacoes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/lembretes/cadastro/',
	      	name: 'CadastrarNotificacoes',
	      	meta: {
	      		title: 		"Novo lembrete",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarNotificacoes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/lembretes/editar/',
	      	name: 'EditarNotificacoes',
	      	meta: {
	      		title: 		"Editar lembrete",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarNotificacoes,
	      	beforeEnter: checkLogin,
	    },	    		    	      
	    {
	      	path: '/vendas/',
	      	name: 'Vendas',
	      	meta: {
	      		title: 		"Vendas - granel",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Pedidos,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/documentos/',
	      	name: 'Arquivos',
	      	meta: {
	      		title: 		"Documentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: Arquivos,
	      	beforeEnter: checkLogin,
	    },	 	
	    {
	      	path: '/pagamentos/',
	      	name: 'Pagamentos',
	      	meta: {
	      		title: 		"Dados para pagamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial", "contratante"],
	      	},
	      	component: Pagamentos,
	      	beforeEnter: checkLogin,
	    },	 		           
	    {
	      	path: '/vendas/cadastro/',
	      	name: 'CadastrarVendas',
	      	meta: {
	      		title: 		"Nova venda - granel",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/vendas/editar/',
	      	name: 'EditarVendas',
	      	meta: {
	      		title: 		"Editar venda",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/abastecimentos/cadastro/',
	      	name: 'CadastrarPedidos',
	      	meta: {
	      		title: 		"Cadastrar abastecimento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/abastecimentos/gerenciar/',
	      	name: 'EditarPedidos',
	      	meta: {
	      		title: 		"Concluir abastecimento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: GerenciarPedidos,
	      	beforeEnter: checkLogin,
	    },		        
	    {
	      	path: '/premios/',
	      	name: 'Premios',
	      	meta: {
	      		title: 		"Prêmios",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Premios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/minha-conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Minha conta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "prestador", "gerencial"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/chat/',
	      	name: 'Chat',
	      	meta: {
	      		title: 		"Chat",
		      	backButton: true,
		      	auth: 		true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: Chat,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/pilotos/',
	      	name: 'UsuariosContratante',
	      	meta: {
	      		title: 		"Pilotos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar piloto",
		      		"cadastrarBotaoNome": 		"CadastrarUsuariosContratante",
		      		"editarBotaoNome": 			"EditarUsuariosContratante",
		      		"tipo": 					"contratante" 
		      	}
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/usuarios/',
	      	name: 'UsuariosGeral',
	      	meta: {
	      		title: 		"Usuários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuariosGeral",
		      		"editarBotaoNome": 			"EditarUsuariosGeral",
		      		"tipo": 					"admin,prestador,gerencial" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/clientes/',
	      	name: 'Clientes',
	      	meta: {
	      		title: 		"Clientes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"],
	      	},
	      	component: Clientes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/catalogo/',
	      	name: 'Catalogo',
	      	meta: {
	      		title: 		"Produtos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: Catalogo,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/filiais/',
	      	name: 'Empresas',
	      	meta: {
	      		title: 		"Filiais",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Empresas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/metas/cadastro',
	      	name: 'CadastrarMetas',
	      	meta: {
	      		title: 		"Cadastrar meta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarMetas,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/metas/editar',
	      	name: 'EditarMetas',
	      	meta: {
	      		title: 		"Editar meta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarMetas,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/produtos/cadastro',
	      	name: 'CadastrarCatalogo',
	      	meta: {
	      		title: 		"Cadastrar produto",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarCatalogo,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/produtos/editar',
	      	name: 'EditarCatalogo',
	      	meta: {
	      		title: 		"Editar produto",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarCatalogo,
	      	beforeEnter: checkLogin,
	    },	 	     
	    {
	      	path: '/filiais/cadastro',
	      	name: 'CadastrarEmpresas',
	      	meta: {
	      		title: 		"Cadastrar filial",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEmpresas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/filiais/editar',
	      	name: 'EditarEmpresas',
	      	meta: {
	      		title: 		"Editar filial",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarEmpresas,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/estoque',
	      	name: 'Estoque',
	      	meta: {
	      		title: 		"Gerenciamento de estoque",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: Estoque,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/relatorios',
	      	name: 'Relatorios',
	      	meta: {
	      		title: 		"Relatórios",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: Relatorios,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/estoque/cadastro',
	      	name: 'CadastrarEstoque',
	      	meta: {
	      		title: 		"Cadastrar estoque",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: GerenciarEstoque,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/controle-tanque-armazenamento',
	      	name: 'GerenciarEstoqueArmazenamento',
	      	meta: {
	      		title: 		"Controle tanque de armazenamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: GerenciarEstoqueArmazenamento,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/estoque/movimentar',
	      	name: 'MovimentarEstoque',
	      	meta: {
	      		title: 		"Movimentar estoque",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: MovimentarEstoque,
	      	beforeEnter: checkLogin,
	    },	    	
	    {
	      	path: '/estoque/editar',
	      	name: 'EditarEstoque',
	      	meta: {
	      		title: 		"Editar estoque",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: GerenciarEstoque,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/clientes/cadastro',
	      	name: 'CadastrarClientes',
	      	meta: {
	      		title: 		"Cadastrar cliente",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: GerenciarClientes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/clientes/editar',
	      	name: 'EditarClientes',
	      	meta: {
	      		title: 		"Editar cliente",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "gerencial"]
	      	},
	      	component: GerenciarClientes,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/pilotos/cadastro',
	      	name: 'CadastrarUsuariosContratante',
	      	meta: {
	      		title: 		"Cadastrar piloto",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/pilotos/editar',
	      	name: 'EditarUsuariosContratante',
	      	meta: {
	      		title: 		"Editar piloto",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"tipo": "contratante" 
		      	}		      	
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuariosGeral',
	      	meta: {
	      		title: 		"Cadastrar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuariosGeral',
	      	meta: {
	      		title: 		"Editar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"tipo": 					"admin,prestador,gerencial" 
		      	}		      	
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	    		    	        
	    {
	      	path: '/premios/cadastro',
	      	name: 'CadastrarPremios',
	      	meta: {
	      		title: 		"Cadastrar prêmio",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "gerencial"],
	      	},
	      	component: GerenciarPremios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/premios/editar',
	      	name: 'EditarPremios',
	      	meta: {
	      		title: 		"Editar prêmio",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "gerencial"],
	      	},
	      	component: GerenciarPremios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/historico/',
	      	name: 'Logs',
	      	meta: {
	      		title: 		"Histórico de atividades",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "gerencial"],
	      	},
	      	component: Logs,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/precos-especiais/',
	      	name: 'PrecosEspeciais',
	      	meta: {
	      		title: 		"Preços especiais",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"],
	      	},
	      	component: PrecosEspeciais,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/clientes-granel/',
	      	name: 'PrecosEspeciaisGranel',
	      	meta: {
	      		title: 		"Clientes a granel",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "gerencial"],
	      	},
	      	component: PrecosEspeciaisGranel,
	      	beforeEnter: checkLogin,
	    },	 	    	       
	    {
	      	path: '/premios/resgatar/',
	      	name: 'ResgatarPremios',
	      	meta: {
	      		title: 		"Resgatar prêmio",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante"],
	      	},
	      	component: ResgatarPremios,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/premios/resgate/',
	      	name: 'ResgatePremios',
	      	meta: {
	      		title: 		"Detalhes do resgate",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador", "contratante", "gerencial"],
	      	},
	      	component: ResgatePremios,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/pre-agendamento/',
	      	name: 'PreAgendar',
	      	meta: {
	      		title: 		"Novo pré-agendamento",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante"],
	      	},
	      	component: PreAgendar,
	      	beforeEnter: checkLogin,
	    },	    
	    { path: '*', redirect: '/' }
  	]
})

const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".dashboard-content-inner")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop;
	    console.log("Setou scroll top", scrollPositions[from.name])
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".dashboard-content-inner")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	  		setTimeout(function() {
		    	element.scrollTop = scrollPositions[currentRouteName];
		    	console.log("Setou scrollPositions", scrollPositions[currentRouteName]);
		    	scrollPositions[currentRouteName] = null;
	  		}, 400);
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js